import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(120)};
`

export const Wrapper = styled(Container)``

export const Image = styled(CustomImage)`
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-height: 690px;
  img {
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    border-bottom-left-radius: 0px;

    img {
      border-bottom-left-radius: 0px;
    }
  }
`

export const Pattern = styled(CustomImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }
`

export const Logo = styled(CustomImage)``

export const InfoWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const InfoContainer = styled.div`
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
  background: #d9f1eb;
  backdrop-filter: blur(2.5px);
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 1rem 2rem 1rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    border-top-right-radius: 0;
    border-bottom-right-radius: 18px;
    border-bottom-left-radius: 18px;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled.div`
  margin-bottom: 1.5rem;
  margin-top: 2.5rem;
  p,
  span {
    color: ${({ theme }) => theme.palette.primary.dark};
    font-size: ${({ theme }) => theme.typography.pxToRem(40)};
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
  }

  span {
    color: ${({ theme }) => theme.palette.tertiary.dark};
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-top: 0;
    margin-bottom: 1.25rem;
    p,
    span {
      max-width: 472px;
      font-size: ${({ theme }) => theme.typography.pxToRem(37)};
      font-weight: 500;
    }
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.9;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(40)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 472px;
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(48)};
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 472px;
  }
`
